import axios from "@/util/axios";

export default {
  namespaced: true,
  state () {
    return {
      notifications: []
    }
  },
  mutations: {
    setNotifications(state, payload) {
      state.notifications = payload
    },
  },
  actions: {
    getNotifications({commit}){
      axios.get('/unread-notifications')
          .then(({ data }) => {
            commit('setNotifications', data.data)
          })
    }
  },
  getters: {
    notificationList: (state) => state.notifications
  }
}